export default "__VITE_ASSET__7uuiDJss__"